import { FunctionComponent, ReactNode } from 'react';
import styled from '@emotion/styled';

import { YOUTUBE_LIST } from '../../constant/youtube';
import { Music } from '../atoms/Music';

interface Props {
  children?: ReactNode;
}

export const MainPage: FunctionComponent<Props> = () => {
  return (
    <PageWrapper>
      {YOUTUBE_LIST?.map((music, index) => (
        <Music {...music} key={`music-${index}`} />
      ))}
    </PageWrapper>
  );
};
const PageWrapper = styled.div`
  display: flex;
  flex: 1;

  flex-direction: column;

  color: white;

  gap: 16px;
  justify-content: center;
  align-items: center;

  .play-button {
    border: 10px solid #fff;
    border-radius: 50%;
    height: 100px;
    width: 100px;
  }
`;
